var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCateClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.024 8.49673H17.5322V5.00493C17.5322 3.74819 17.0226 2.61056 16.2 1.7866C15.3746 0.962634 14.2363 0.453735 12.9796 0.453735C10.4668 0.453735 8.42697 2.49145 8.42697 5.00493V8.49673H4.93587C2.42098 8.49673 0.38327 10.5351 0.38327 13.0493C0.38327 15.5628 2.42098 17.6019 4.93587 17.6019H8.42697V21.0937C8.42697 23.6072 10.4668 25.6449 12.9796 25.6449C15.4945 25.6449 17.5322 23.6072 17.5322 21.0937V17.6019H21.024C22.2821 17.6019 23.4197 17.0923 24.2423 16.2691C25.0663 15.4444 25.5766 14.3068 25.5766 13.05C25.5766 10.5351 23.5375 8.49673 21.024 8.49673ZM20.9302 16.6046H9.56741V5.02184C9.56741 3.13638 11.0948 1.60827 12.9803 1.60827C13.9227 1.60827 14.7769 1.9903 15.393 2.60774C16.0104 3.22589 16.3924 4.07946 16.3924 5.02184V9.62801H20.9309C22.8397 9.62801 24.3861 11.1744 24.3861 13.0846V13.1487C24.3861 15.0574 22.839 16.6046 20.9302 16.6046Z",
    fill: "#8B87A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCateClinic);
export default __webpack_public_path__ + "static/media/cateClinic.4fc4254c5d8bb79c2335ce391d4a906b.svg";
export { ForwardRef as ReactComponent };